import {createClient} from '@sanity/client';

export default createClient({
  projectId: "msky1t7h",
  dataset: "production",
  useCdn: true, // `false` if you want to ensure fresh data
  apiVersion: "2025-07-26"
});